import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-76d26de6")
const _hoisted_1 = {
  id: "planning_page",
  class: "page minh0"
}
const _hoisted_2 = { class: "p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = {
  key: 0,
  class: "filters"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map p-mr-2 p-p-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar p-mr-2 p-p-2" }, null, -1)
const _hoisted_7 = { class: "planning_section minh0" }
const _hoisted_8 = { class: "data_column card p-mb-0 p-fluid" }
const _hoisted_9 = { class: "p-d-flex pi-ai-center" }
const _hoisted_10 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "p-p-4 p-text-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", null, "Nessun ordine da assegnare", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "p-mt-auto" }
const _hoisted_18 = { class: "map_section card p-mb-0" }
const _hoisted_19 = { class: "p-field-checkbox p-mb-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "binary" }, "Nascondi assegnati", -1)
const _hoisted_21 = {
  id: "map",
  ref: "mapEl"
}
const _hoisted_22 = { class: "data_column card p-mb-0 p-fluid" }
const _hoisted_23 = { class: "p-d-flex pi-ai-center" }
const _hoisted_24 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_25 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Nessun taker disponibile", -1)
const _hoisted_28 = {
  key: 1,
  style: {"height":"2.5rem","display":"flex"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "Mezzi a disposizione: ", -1)
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 3,
  class: "p-p-4 p-text-center"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", null, "Nessun ordine assegnato.", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "p-mt-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Confermare la configurazione attuale?", -1)
const _hoisted_36 = { class: "p-my-3" }
const _hoisted_37 = { class: "p-text-center" }
const _hoisted_38 = { class: "p-d-flex p-jc-end" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_ShiftToText = _resolveComponent("ShiftToText")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_SelectVehicleInfo = _resolveComponent("SelectVehicleInfo")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderOnMapList = _resolveComponent("OrderOnMapList")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_MapLegend = _resolveComponent("MapLegend")!
  const _component_SelectTakerInfo = _resolveComponent("SelectTakerInfo")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('planning.title')), 1)
      ]),
      (_ctx.orders)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.zone)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 0,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.zone.name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.date)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 1,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_DateFormatted, { date: _ctx.date }, null, 8, ["date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.shift)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 2,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ShiftToText, { shift: _ctx.shift }, null, 8, ["shift"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_FloatLabel, {
            class: "flex1",
            label: "Tipologia"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.vehicle,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.vehicle = $event)),
                options: _ctx.vehicles,
                optionLabel: "name_it",
                placeholder: "Tipologie",
                loading: !_ctx.vehicles || !_ctx.vehicles.length,
                onChange: _ctx.onChangeVehicle
              }, _createSlots({
                option: _withCtx(({option}) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(option.name_it), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Badge, {
                        value: _ctx.getNaoNumFor(option.id),
                        severity: "info"
                      }, null, 8, ["value"])
                    ])
                  ])
                ]),
                _: 2
              }, [
                (_ctx.vehicle)
                  ? {
                      name: "value",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.vehicle.name_it), 1),
                          _createElementVNode("div", null, [
                            _createVNode(_component_Badge, {
                              value: _ctx.getNaoNumFor(_ctx.vehicle.id),
                              severity: "info"
                            }, null, 8, ["value"])
                          ])
                        ])
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "options", "loading", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_SelectVehicleInfo)
        ]),
        (_ctx.requestPending)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "p-my-2"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.naoFilteredByVehicle && _ctx.naoFilteredByVehicle.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Ordini con il mezzo selezionato: "))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
            ])),
        _createVNode(_component_OrderOnMapList, {
          isLoading: _ctx.requestPending,
          orders: _ctx.naoFilteredByVehicle,
          selectedIds: _ctx.selectedOrdersId
        }, {
          action: _withCtx(({order}) => [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-rounded p-button-success p-button-outlined",
              onClick: ($event: any) => (_ctx.assignOrder(order))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["isLoading", "orders", "selectedIds"]),
        _createElementVNode("footer", _hoisted_17, [
          _createElementVNode("small", null, "Ordini totali: " + _toDisplayString(_ctx.orders && _ctx.orders.length), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createVNode(_component_Toolbar, { class: "p-mb-2" }, {
          start: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              label: "SALVA",
              onClick: _ctx.save
            }, null, 8, ["onClick"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Checkbox, {
                id: "binary",
                binary: true,
                modelValue: _ctx.hideAssigned,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideAssigned = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_20
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_MapLegend),
        _createElementVNode("div", _hoisted_21, null, 512)
      ]),
      _createElementVNode("section", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_FloatLabel, {
            class: "flex1",
            label: "Taker"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedTaker,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTaker = $event)),
                options: _ctx.takersByVehicle,
                optionLabel: "taker.name",
                placeholder: "Takers",
                onChange: _ctx.onTakerSelect
              }, {
                value: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.selectedTakerName), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Badge, {
                        value: _ctx.getAssignedOrdersNum(_ctx.selectedTakerId),
                        severity: "info"
                      }, null, 8, ["value"])
                    ])
                  ])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, _toDisplayString(option.taker.name) + " " + _toDisplayString(option.taker.surname), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Badge, {
                        value: _ctx.getAssignedOrdersNum(option.taker.id),
                        severity: "info"
                      }, null, 8, ["value"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_SelectTakerInfo)
        ]),
        (!_ctx.takers?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_Message, {
                severity: "error",
                closable: false
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTaker)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTakerVehicle, (v) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `${_ctx.selectedTaker.taker.id}_v_${v.vehicle_id}`
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`fas fa-${v.vehicle.icon} p-ml-2`),
                      title: v.vehicle.name_it
                    }, null, 10, _hoisted_30)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.takerOrders && _ctx.takerOrders.length)
          ? (_openBlock(), _createBlock(_component_OrderOnMapList, {
              key: 2,
              isLoading: _ctx.requestPending,
              orders: _ctx.takerOrders,
              selectedIds: _ctx.selectedOrdersId
            }, {
              action: _withCtx(({order}) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-times",
                  class: "p-button-rounded p-button-danger p-button-outlined",
                  onClick: ($event: any) => (_ctx.unassignOrder(order))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["isLoading", "orders", "selectedIds"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33)),
        _createElementVNode("footer", _hoisted_34, [
          _createElementVNode("small", null, " Ordini assegnati: " + _toDisplayString(_ctx.assignedOrders && _ctx.assignedOrders.length), 1)
        ])
      ])
    ]),
    _createVNode(_component_PDialog, {
      draggable: "",
      keepInViewPort: "",
      minX: 0,
      minY: 0,
      header: _ctx.saveHeader,
      visible: _ctx.savingDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.savingDialog = $event)),
      onHide: _ctx.onHide
    }, {
      default: _withCtx(() => [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.progressMessage), 1),
          (_ctx.isSavingInProgress)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                showValue: false
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_Button, {
            label: "Annulla",
            class: "p-mr-2",
            onClick: _ctx.cancelSave
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "Conferma",
            onClick: _ctx.confirmSave
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible", "onHide"])
  ]))
}